import Auth from "@/components/General/Auth/auth";
import router from "@/router";
import { renewSessionNow } from "@/components/ExternalApps/composables/useAuthentication";

// Receives the fetch Response of a failed request.
export const SalesChannelManagementAuth = response => {
  if (response?.status !== 401) return;
  // A session that merely expired (e.g. the device slept past it) is renewed in place.
  if (renewSessionNow()) return;
  Auth.logout();
  // Reload so the Auth view runs a fresh handshake with a clean page-level refresh state.
  const reload = () => window.location.reload();
  router.push({ name: "salesChannelManagementAuth" }).then(reload, reload);
};
